export interface IRecordsReceivedRequest {
  caseLineItemId: number
  recordsReceivedDate: Date
}

export class RecordsReceivedRequest implements IRecordsReceivedRequest {
  public caseLineItemId: number
  public recordsReceivedDate: Date
}
